import classNames from 'classnames'

import styles from './Label.module.scss'

type Props = {
  label: string
  className?: string
}

export const Label = ({ label, className }: Props) => (
  <p className={classNames(styles.label, className)}>
    {label.split('\n').map((line, i) => (
      <span key={i}>
        {i > 0 && <br />}
        {line}
      </span>
    ))}
  </p>
)
